export default "__VITE_ASSET__DtFdsIVE__"